<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Select from '$components/Form/Select.svelte';
    import Textarea from '$components/Form/Textarea.svelte';
    import find from 'lodash/find';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const productTypesOptions = [
        `Médicaments sur ordonnance`,
        `Produits cosmétiques`,
        `Compléments alimentaires`,
        `Equipements médicaux`,
        `Autres (veuillez préciser)`,
    ].map((v) => ({ label: v, value: v }));

    const purchaseFrequencyOptions = [
        `Hebdomadaire`,
        `Mensuelle`,
        `Occasionnelle`,
        `Autre (veuillez préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const healthServicesOptions = [
        `Oui, je suis intéressé par des conseils diététiques`,
        `Oui, je suis intéressé par des conseils en cosmétologie`,
        `Oui, je suis intéressé par des conseils en phytothérapie ou aromathérapie`,
        `Non, je ne suis pas intéressé pour le moment`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.pharmacies.productTypes}
        class=""
        let:field
        let:id
        label={`Quels types de produits ou services recherchez-vous principalement dans une pharmacie ?`}
    >
        <MeltMultiSelect
            {form}
            {field}
            {id}
            placeholder=""
            options={productTypesOptions}
            valueToOption={(v) => ({
                value: v,
                label: find(productTypesOptions, (o) => o.value === v)?.label ?? '',
            })}
        />
    </Row>

    <Row
        {form}
        field={fields.pharmacies.purchaseFrequency}
        class=""
        let:field
        let:id
        label={`À quelle fréquence achetez-vous des produits pharmaceutiques ou parapharmaceutiques ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={purchaseFrequencyOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.pharmacies.healthServices}
        class=""
        let:field
        let:id
        label={`Êtes-vous intéressé par des conseils ou des services supplémentaires liés à la santé et au bien-être ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={healthServicesOptions}
            placeholder="Sélectionnez une option"
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
